export enum eUser {
  USER = 'USER',
}
